"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SCRIPT_STATUS = void 0;
var _react = require("react");
const EVENT_TYPE = {
  LOAD: 'load',
  ERROR: 'error'
};
const STATUS_ATTR_ID = 'data-status';
const SCRIPT_STATUS = exports.SCRIPT_STATUS = {
  IDLE: 'idle',
  ERROR: 'error',
  LOADING: 'loading',
  READY: 'ready'
};
const useScriptInjector = options => {
  const {
    src = '',
    id = '',
    isAsync = true
  } = options || {};
  const [status, setStatus] = (0, _react.useState)(src ? SCRIPT_STATUS.LOADING : SCRIPT_STATUS.IDLE);
  (0, _react.useEffect)(() => {
    let scriptInDOM = document.querySelector(`script[src="${src}"]`);
    const setAttributeFromEvent = event => {
      const scriptStatus = event.type === EVENT_TYPE.LOAD ? SCRIPT_STATUS.READY : SCRIPT_STATUS.ERROR;
      scriptInDOM.setAttribute(STATUS_ATTR_ID, scriptStatus);
      setStatus(scriptStatus);
    };
    if (!scriptInDOM) {
      scriptInDOM = document.createElement('script');
      scriptInDOM.id = id;
      scriptInDOM.src = src;
      scriptInDOM.async = isAsync;
      scriptInDOM.setAttribute(STATUS_ATTR_ID, SCRIPT_STATUS.LOADING);
      try {
        document.body.appendChild(scriptInDOM);
        scriptInDOM.addEventListener(EVENT_TYPE.LOAD, setAttributeFromEvent);
        scriptInDOM.addEventListener(EVENT_TYPE.ERROR, setAttributeFromEvent);
      } catch (e) {
        setStatus(SCRIPT_STATUS.ERROR);
      }
    } else if (scriptInDOM.getAttribute(STATUS_ATTR_ID) === SCRIPT_STATUS.LOADING) {
      scriptInDOM.addEventListener(EVENT_TYPE.LOAD, setAttributeFromEvent);
      scriptInDOM.addEventListener(EVENT_TYPE.ERROR, setAttributeFromEvent);
    } else {
      setStatus(scriptInDOM.getAttribute(STATUS_ATTR_ID));
    }
    return () => {
      if (scriptInDOM) {
        scriptInDOM.removeEventListener(EVENT_TYPE.LOAD, setAttributeFromEvent);
        scriptInDOM.removeEventListener(EVENT_TYPE.ERROR, setAttributeFromEvent);
      }
    };
  }, [src]);
  return status;
};
var _default = exports.default = useScriptInjector;